export const RideBulkActionFields = {
  stationBulkFromId: "stationBulkFromId",
  stationBulkToId: "stationBulkToId",
  onlyExistingBulkStations: "onlyExistingBulkStations",
} as const;

export type IRideBulkActionsFormModel = {
  [
    K in keyof typeof RideBulkActionFields
  ]?: K extends "onlyExistingBulkStations" ? boolean : number;
};

export enum RideBulkActionModeEnum {
  Menu = "Menu",
  UpdateStations = "UpdateStations",
  MovePassengers = "MovePassengers",
}

export enum RideBulkMoveTargetEnum {
  NewRide = "NewRide",
  ExistingRide = "ExistingRide",
}

export const RideBulkMoveFields = {
  moveTarget: "moveTarget",
  targetRideId: "targetRideId",
} as const;

export interface IRideBulkMoveFormModel {
  moveTarget: RideBulkMoveTargetEnum;
  targetRideId?: number;
}
